import Freeform from "./components/Freeform";
import UserHabitContainer from "../habits/UserHabitContainer";
export default UserHabitContainer(Freeform);
